import DatePicker from './component'

export default DatePicker
